import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { GlobalService } from 'src/app/_services/global.service';
import { ErrorMsgService } from 'src/app/shared/error-msg/error-msg.service';
import { SectionsService } from '../_services/sections.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { MultiSelect } from 'primeng/multiselect/multiselect';
import { AmplitudeService } from 'src/app/_services/amplitude.service';

declare var $: any;

@Component({
  selector: 'app-add-section',
  templateUrl: './add-section.component.html',
  styleUrls: ['./add-section.component.scss']
})
export class AddSectionComponent implements OnInit {
  mode: string = 'add';
  sectionId;
  sectionName: string = '';
  sectionForm: UntypedFormGroup;
  loading = false;
  currLang;
  allGrades = [];
  selectedGrades = [];
  @ViewChild('multiSelect') multiSelect: MultiSelect;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private globalService: GlobalService,
    private ref: ChangeDetectorRef,
    private errorMsgService: ErrorMsgService,
    private sectionsServise: SectionsService,
    private dataService: DataService,
    private amplitudesService: AmplitudeService
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.sectionId = params.id;
      this.mode = params.mode;
    });
  }

  ngOnInit(): void {
    // to remove the black screen and the stuck error msg popup if error message was just closed in sibling component 
    $('.modal').modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.dataService.getAllGrades().subscribe(res => {
      this.allGrades = res?.map(grade => ({
        value: grade.id,
        label: grade.name,
        classes: grade.school_classes
      }));
    });
    if (this.mode == "edit") {
      // using local storage instead of observable to prevent bug on reload as observable resets
      this.setEditData(JSON.parse(localStorage.getItem('sectionEditData')))
      // this.sectionsServise.getSectionData().subscribe((res:any) => {
      //   this.setEditData(res)
      // })
    }
  }


  saveSection() {
    this.amplitudesService.trackEvent('CTA.Save_Section',{})
    this.loading = true;
    let body:any = {};
    body.name = this.sectionName;
    body.grades = this.selectedGrades;
    switch (this.mode) {
      case "add":
        this.sectionsServise.addSection(body).subscribe(res => {
        }, err => {
          this.loading = false;
          this.errorHanding(err);
        }, () => {
          this.mode = "add";
          this.back();
          this.loading = false;
        });
        break;

      case "edit":
        this.sectionsServise.updateSection(this.sectionId,body).subscribe(res => {
        }, err => {
          this.loading = false;
          this.errorHanding(err);
        }, () => {
          this.mode = "add";
          this.back();
          this.loading = false;
        });
        break;
    }
  }

  setEditData(data) {
    this.sectionName = data?.name;
    this.sectionId = data?.id;
    this.selectedGrades = data?.grades?.map(grade => grade.id);
  }

  back() {
    this.router.navigate([`school-management/sections`]);
  }

  onGradeSelectionChange(e) {
    // to make the dropdown still opened 
    this.multiSelect.show();
    e?.originalEvent?.stopPropagation();
    this.amplitudesService.trackEvent('Select.Section_Classes_Dropdown',{})
  }

  onNameChange(e) {
    this.amplitudesService.trackEvent('Click.Section_Name',{})
  }

  errorHanding(err:any){
    if(err?.error?.errors){
      if(err?.error?.errors?.grades){
        // this.errorMsgService.setReloadOnClose(true);
        this.errorMsgService.setMessage(err.error.errors.grades[0]);
      }
      if(err?.error?.errors?.name){
        this.errorMsgService.setMessage(err.error.errors.name[0]);
      }
    }
    else{
      this.errorMsgService.setMessage(err.error.message);
    }
  }

  ngOnDestroy() {    
    this.errorMsgService.setMessage(null);
  }
}
